export default "<h1>{{ 'home-page.title' | translate }}</h1>\r\n";